import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import HTMLRenderer from 'react-html-renderer'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'

const ErrorContainer = styled.div`
  width: 100%;
  text-align: center;
  margin: ${rem(24)} 0;

  > div {
    margin-top: ${rem(8)};
  }
`

const FlexContent = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  > svg {
    margin-right: ${rem(4)};
  }

  > div a {
    font-weight: 500;
    font-size: ${rem(14)};
    line-height: ${rem(20)};
    text-decoration: underline;
  }
`

interface Props {
  textToRender: string
}

const CruiseErrorRenderer = ({ textToRender }: Props) => {
  return (
    <ErrorContainer>
      <HTMLRenderer
        html={textToRender}
        components={{
          svg: () => <LinePhoneIcon size="S" />,
          div: ({ children }) => <FlexContent>{ children }</FlexContent>,
          span: ({ children }) => <BodyText variant="medium">{children}</BodyText>,
          h4: ({ children }) => <Heading variant="heading4" as="span">{children}</Heading>,
        }}
      />
    </ErrorContainer>
  )
}

export default CruiseErrorRenderer
